/**
 * Преобразует сырой wssReason из API в читаемые пользователю подписи.
 */

const WSS_REASON_LABELS: Record<string, string> = {
  significant_growth: 'Strong growth — mentions in spike window above baseline',
  decline: 'Declining interest — mentions below baseline',
  no_growth: 'Flat or weak growth — no significant increase',
  insufficient_data: 'Insufficient data',
};

export function formatWssReason(reason: string | undefined | null): string {
  if (!reason || reason.trim() === '') return '';
  const key = reason.toLowerCase().replace(/\s+/g, '_');
  return WSS_REASON_LABELS[key] ?? reason.replace(/_/g, ' ');
}
